import { apiGet, apiPost } from "@/shared/api";
import { leggiImportoEuro } from "@/shared/importo";

/** Rimborso al cliente scritto a mano (ManoMano, BricoBravo, Amazon: l'API non dice quanto). */
export type TipoRimborso = "parziale" | "totale";

export interface StatoRimborso {
  order_id: number;
  stato: "da_decidere" | "deciso" | "non_serve";
  motivo: "stato" | "messaggio" | null;
  tipo: TipoRimborso | null;
  /** IVA compresa; il server può mandarlo come testo. Vuoto se totale. */
  importo_lordo: number | string | null;
  scritto_da: string;
  scritto_il: string | null;
}

const BASE = "/api/rimborsi-manuali";

export const leggiRimborso = (ordine: string) =>
  apiGet<StatoRimborso>(`${BASE}?ordine=${encodeURIComponent(ordine)}`);

export const salvaRimborso = (ordine: string, tipo: TipoRimborso, importoLordo?: number) =>
  apiPost<unknown>(
    BASE,
    tipo === "parziale" ? { ordine, tipo, importo_lordo: importoLordo } : { ordine, tipo },
  );

/** «12,50» o «12.50» → 12.5. Vuoto, zero o testo → null. */
export function leggiImporto(testo: string): number | null {
  return leggiImportoEuro(testo);
}
